export const ADD_TO_BUY_NOW = 'ADD_TO_BUY_NOW';
export const CLEAR_BUY_NOW = 'CLEAR_BUY_NOW';

export const addToBuyNow = (product) => ({
  type: ADD_TO_BUY_NOW,
  payload: product,
});

export const clearBuyNow = () => ({
  type: CLEAR_BUY_NOW,
});